import moment from 'moment';
import { apiRequest } from '@/calls/helpers';

const authenticate = async ({ email, orderreference }) => {
  try {
    const request = await apiRequest('sapiti.php', {
      method: 'GET',
      endpoint: '/contacts',
      data: { email, orderreference }
    });

    const { response } = request;

    return {
      success: request.proxy_success,
      error: request.proxy_error,
      data: response
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const update = async (datas, id) => {
  try {
    const request = await apiRequest('sapiti.php', {
      method: 'PATCH',
      endpoint: `/contacts/${id}`,
      data: { ...datas }
    });

    const { response } = request;

    return {
      success: request.proxy_success,
      error: request.error,
      data: response
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const search = async (params) => {
  try {
    const request = await apiRequest('sapiti.php', {
      method: 'GET',
      endpoint: '/contacts',
      data: { ...params }
    });

    const { response } = request;

    return {
      success: request.proxy_success,
      error: request.proxy_error,
      data: response
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const create = async (datas) => {
  try {
    const request = await apiRequest('sapiti.php', {
      method: 'POST',
      endpoint: '/contacts/',
      data: { ...datas }
    });

    const { response } = request;

    return {
      success: request.proxy_success,
      error: request.proxy_error,
      data: response
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const getStreamOrders = async (contactid) => {
  try {
    const request = await apiRequest('sapiti.php', {
      method: 'GET',
      endpoint: '/shop/products',
      data: {
        contactid,
        typeid: 2001
      }
    });

    const data = request.response;
    const tickets = [];

    for (let i = 0; i < data.length; i++) {
      const ticket = data[i];
      const stocks = tickets.map(t => t.stockid);
      const index = stocks.indexOf(ticket.stockid);

      if (index >= 0) {
        tickets[index].access.push(ticket.accesscode);
      } else {
        const req = await apiRequest('sapiti.php', {
          method: 'GET',
          endpoint: `/shop/products/stocks/${ticket.stockid}`
        });

        const { streamid } = req.response;

        const r = await apiRequest('sapiti.php', {
          method: 'GET',
          endpoint: `/catalogue/streams/${streamid}`
        });

        const stream = r.response;
        const d = moment(stream.starttime);

        tickets.push({
          stream: true,
          stockid: ticket.stockid,
          eventid: stream.id,
          attractionid: stream.attraction.id,
          title: stream.label,
          location: stream.venue.label,
          picture: stream.attraction.image_url,
          access: [ticket.accesscode],
          url: stream.url,
          date: {
            day: d.format('dddd'),
            date: d.format('D'),
            month: d.format('MMMM'),
            year: d.format('YYYY'),
            hours: d.format('H'),
            minutes: d.format('mm'),
            full: stream.starttime
          }
        });
      }
    }

    return {
      status: 'success',
      data: tickets
    };
  } catch (error) {
    return {
      status: 'error',
      data: error
    };
  }
};

const getOrders = async (params) => {
  try {
    const request = await apiRequest('sapiti.php', {
      method: 'GET',
      endpoint: '/shop/orders/tickets',
      data: {
        contactid: params.contactid
      }
    });

    const ticketsets = request.response;
    let tickets = [];

    moment.locale('FR');

    for (let i = 0; i < ticketsets.length; i++) {
      const ticketset = ticketsets[i];
      const req = await apiRequest('sapiti.php', {
        method: 'GET',
        endpoint: `/shop/products/stocks/${ticketset.stockid}`
      });

      const { eventid } = req.response;
      const r = await apiRequest('sapiti.php', {
        method: 'GET',
        endpoint: `/agenda/events/${eventid}`
      });

      const event = r.response;
      const d = moment(event.starttime);

      // eslint-disable-next-line
      const ticks = ticketset.tickets.map(tick => {
        return {
          id: tick.id,
          title: tick.positionlabel,
          attraction: event.attraction.label,
          category: tick.categorylabel,
          qrcode: tick.qrcode
        };
      });

      tickets.push({
        stockid: ticketset.stockid,
        eventid: event.id,
        attractionid: event.attraction.id,
        title: event.attraction.label,
        location: event.venue.label,
        picture: event.attraction.image_url,
        tickets: ticks,
        date: {
          day: d.format('dddd'),
          date: d.format('D'),
          month: d.format('MMMM'),
          year: d.format('YYYY'),
          hours: d.format('H'),
          minutes: d.format('mm'),
          full: event.starttime
        }
      });
    }

    const streams = await getStreamOrders(params.contactid);

    if (streams.status === 'success' && streams.data) {
      tickets = tickets.concat(streams.data);
    }

    // eslint-disable-next-line
    tickets.sort(function(a, b) {
      return new Date(a.date.full) - new Date(b.date.full);
    });

    tickets.map(ticket => {
      const { date } = ticket;
      ticket.date.label = `${date.day.charAt(0).toUpperCase() + date.day.slice(1)} ${date.date} ${date.month.charAt(0).toUpperCase() + date.month.slice(1)} ${date.year} à ${date.hours}:${date.minutes}`;
      return ticket;
    });

    return {
      success: request.proxy_success,
      error: request.proxy_error,
      data: tickets
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const getUserPref = async (user) => {
  try {
    const request = await apiRequest('/pref.php', {
      user,
      pref: null
    });

    return {
      success: true,
      error: false,
      data: request.pref
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const updateUserPref = async ({ user, pref }) => {
  try {
    // eslint-disable-next-line
    const request = await apiRequest('/pref.php', {
      user, pref
    });

    return {
      success: true,
      error: false,
      data: request
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

export {
  // eslint-disable-next-line
  update,
  create,
  search,
  getUserPref,
  updateUserPref,
  authenticate,
  getOrders,
  getStreamOrders
};
